export class ApiException extends Error {
  status: number;

  message: string;

  constructor(status: number, message = '') {
    super(message);

    this.status = status;
    this.message = message;
  }
}
